module.exports = __webpack_public_path__ + "img/logo-ct-dark.822a8845.png";